<template>
  <div class="page-wrapper">
    <!-- 使用导航栏组件 -->
    <nav-header v-if="$route.name=='discover'" />
   <TabHeader v-else></TabHeader>
    
    <div class="works-container" v-infinite-scroll="loadMore" infinite-scroll-distance="10">
      <!-- 左侧内容区 -->
      <div class="content-area">
        <!-- 搜索框 -->
        <div class="search-header">
          <el-input
              v-model="searchKey"
              placeholder="搜索你感兴趣的作品..."
              class="search-input"
              prefix-icon="el-icon-search"
              @input="handleSearch"
          >
          </el-input>
        </div>

        <!-- 作品列表 -->
        <div class="works-list">
          <div class="work-card" v-for="(item, index) in worksList" :key="index">
            <router-link
                class="content-card"
                :to=" $route.name=='discover'? '/creation/'+item.id : '/home/creation/detail/'+item.id  "
            >
            <div class="work-content">
              <div class="work-cover">
                <img :src="item.cover" :alt="item.title">
              </div>
              <div class="work-info">
                <h3 class="title">{{ item.title }}</h3>
                <p class="description">{{ item.excerpt }}</p>
                <div class="author-info">
                  <el-avatar :src="item.imUserVo.headImageThumb" :size="24"></el-avatar>
                  <span class="author-name">{{ item.imUserVo.nickName }}</span>
                  <span class="badge" >
                    <i class="el-icon-check"></i>
                  </span>
                </div>
                <div class="stats">
                  <span class="comments" v-if="item.comments">
                    <i class="el-icon-chat-dot-round"></i>
                    {{ item.comments }}条评论
                  </span>
                  <span class="status">{{ item.createTime }}</span>
                </div>
              </div>
            </div>  </router-link>
            <div class="work-price">
              <span class="price">¥{{ item.amt }}</span>
            </div>
          </div>

          <!-- 加载状态 -->
          <div class="loading-status" v-if="loading || finished">
            <p v-if="loading" class="loading">
              <i class="el-icon-loading"></i> 加载中...
            </p>
            <p v-if="finished" class="no-more">没有更多了</p>
          </div>
        </div>
      </div>
      <!-- 右侧分类导航 -->
      <div class="category-nav">
        <div
            class="nav-item"
            v-for="(item, index) in categories"
            :key="index"
            @click="handleCategoryClick(item)"
            :class="{ active: currentCategory === item.value }"
        >
          <div class="icon-wrapper">
            <i :class="item.icon"></i>
          </div>
          <span class="text">{{ item.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavHeader from '@/components/layout/NavHeader.vue'
import _ from 'lodash'
import TabHeader from "@/components/layout/TabHeader.vue";

export default {
  name: 'WorksList',
  
  components: {
    NavHeader,
    TabHeader
  },

  data() {
    return {
      worksList: [], // 作品列表
      page: 1, // 当前页码
      pageSize: 10, // 每页数量
      loading: false, // 是否正在加载
      finished: false, // 是否加载完成
      searchKey: '', // 搜索关键词
      currentCategory: '', // 当前选中的分类
      categories: [

      ]
    }
  },

  created() {
    this.getWorksList()
    // 获取分类列表
    this.$http2({
      url: `/system/dict/data/list?dictType=creation_category`,
      method: 'get',
    }).then((data) => {
      data.rows.forEach((item) => {
        this.categories.push({
          name: item.dictLabel,
          value: item.dictValue,
          icon:item.cssClass
        })
      })
    })
  },

  methods: {
    // 加载更多
    loadMore() {
      if (this.loading || this.finished) return
      this.page++
      this.getWorksList()
    },

    // 获取作品列表
    async getWorksList() {
      try {
        this.loading = true

        // 模拟接口请求
        const res = await this.mockApi()

        // 追加数据
        this.worksList = [...this.worksList, ...res.rows]

        // 判断是否还有更多数据
        if (res.total <= this.worksList.length) {
          this.finished = true
        }
      } catch (error) {
        console.error('获取作品列表失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 模拟接口请求
    mockApi() {
      return   this.$http2({
        method: 'get',
        url: `/creation/explore?pageNum=${this.page}&pageSize=${this.pageSize}&title=${this.searchKey}&category=${this.currentCategory}`
      })
    },

    // 重置列表
    resetList() {
      this.worksList = []
      this.page = 1
      this.finished = false
      this.getWorksList()
    },

    // 搜索处理
    handleSearch: _.debounce(function() {
      this.resetList()
    }, 300),

    // 分类点击处理
    handleCategoryClick(category) {
      if (this.currentCategory === category.value) {
        this.currentCategory = ''
      } else {
        this.currentCategory = category.value
      }
      this.resetList()
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f6f8fa;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.works-container {
  margin-top: 24px;
  display: flex;
  min-height: 100vh;
  background: #f6f8fa;
  padding: 24px;
  gap: 24px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  justify-content: center;
  .content-area {
    margin: 0;
    flex: 1;
    max-width: 800px;
    .search-header {
      margin-bottom: 24px;

      .search-input {
        width: 100%;
        max-width: 500px;
        :deep(.el-input__inner) {
          border-radius: 20px;
          height: 44px;
        }
      }
    }

    .works-list {
      display: flex;
      flex-direction: column;
      gap: 16px;

      .work-card {
        background: #fff;
        border-radius: 12px;
        padding: 20px;
        display: flex;
        justify-content: space-between;
        transition: all 0.3s ease;
        cursor: pointer;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }

        .work-content {
          display: flex;
          gap: 16px;
          flex: 1;

          .work-cover {
            width: 120px;
            height: 80px;
            border-radius: 8px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .work-info {
            flex: 1;

            .title {
              font-size: 16px;
              font-weight: 600;
              color: #333;
              margin: 0 0 8px;
            }

            .description {
              color: #666;
              font-size: 14px;
              line-height: 1.5;
              margin: 0 0 12px;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }

            .author-info {
              display: flex;
              align-items: center;
              gap: 8px;
              margin-bottom: 8px;

              .author-name {
                font-size: 14px;
                color: #666;
              }

              .badge {
                color: #fff;
                background: #ffd700;
                border-radius: 50%;
                width: 16px;
                height: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
              }
            }

            .stats {
              display: flex;
              gap: 16px;
              color: #999;
              font-size: 12px;

              .comments {
                display: flex;
                align-items: center;
                gap: 4px;
              }

              .status {
                color: #666;
              }
            }
          }
        }

        .work-price {
          padding-left: 16px;
          border-left: 1px solid #eee;
          display: flex;
          align-items: center;

          .price {
            color: #ff4d4f;
            font-size: 20px;
            font-weight: 600;
          }
        }
      }

      .loading-status {
        text-align: center;
        padding: 20px 0;
        color: #999;
        font-size: 14px;

        .loading {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .no-more {
          color: #999;
        }
      }
    }
  }

  .category-nav {
    margin: 0;
    width: 100px;
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    position: sticky;
    top: 84px;
    height: fit-content;

    .nav-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 12px 0;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &:hover {
        color: #ff6b00;
      }
      
      &.active {
        color: #ff6b00;
        background: rgba(255, 107, 0, 0.1);
        border-radius: 6px;
      }

      .icon-wrapper {
        font-size: 24px;
        margin-bottom: 4px;
      }

      .text {
        font-size: 14px;
      }
    }
  }
}

// 响应式适配
@media screen and (max-width: 768px) {
  .nav-header {
    .nav-container {
      padding: 0 12px;
      
      .nav-left {
        gap: 20px;
        
        .nav-menu {
          gap: 16px;
          
          .menu-item {
            font-size: 14px;
          }
        }
      }
    }
  }

  .works-container {
    flex-direction: column;
    padding: 16px;

    .category-nav {
      width: 100%;
      order: -1;
      position: sticky;
      top: 60px;
      background: #fff;
      margin-bottom: 16px;
      border-radius: 8px;
      padding: 12px;
      display: flex;
      overflow-x: auto;
      flex-wrap: nowrap;
      
      &::-webkit-scrollbar {
        display: none;
      }

      .nav-item {
        width: auto;
        min-width: 60px;
        padding: 8px 12px;
        flex-shrink: 0;
        flex-direction: column;
        align-items: center;
        
        &.active {
          color: #ff6b00;
          background: rgba(255, 107, 0, 0.1);
          border-radius: 20px;
        }
        
        .icon-wrapper {
          font-size: 20px;
          margin-bottom: 4px;
        }
        
        .text {
          font-size: 12px;
          white-space: nowrap;
        }
      }
    }

    .content-area {
      margin-top: 0;
    }
  }
}

// 滚动条样式
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 3px;
}
</style>